//import node_modules
import React, { FunctionComponent } from "react";
import { Pagination } from "react-bootstrap";
import { If, Then } from "react-if";

//context
import { PaginationContext } from "./hooks/usePaginationContext";

//libs
import { useClassUpdate } from "libs/useClassState";

//hooks
import usePaginationRange from "./hooks/usePaginationRange";

//local components
import PaginationItemComponent from "./components/PaginationItemComponent";
import PageFirst from "./components/PaginationFirstComponent";
import PagePrev from "./components/PaginationPrevComponent";
import PageNext from "./components/PaginationNextComponent";
import PageLast from "./components/PaginationLastComponent";

//types
import type { PaginationState } from "./hooks/usePaginationHandler";

type PagingProps = {
  handler: PaginationState;
  maxButtons: number;
};

const PaginationComponent: FunctionComponent<PagingProps> = ({ handler, maxButtons }) => {
  useClassUpdate(handler);
  const totalPages = handler.getPageCount();
  const pages = usePaginationRange(handler, maxButtons);

  return (
    <PaginationContext value={handler}>
      <Pagination className="justify-content-center">
        <PageFirst />
        <PagePrev />
        <If condition={pages.length > 0 && pages[0] !== 1}>
          <Then>
            <Pagination.Ellipsis disabled={true} />
          </Then>
        </If>
        {pages.map((i) => (
          <PaginationItemComponent key={i} index={i} />
        ))}
        <If condition={pages.length > 0 && pages[pages.length - 1] !== totalPages}>
          <Then>
            <Pagination.Ellipsis disabled={true} />
          </Then>
        </If>
        <PageNext />
        <PageLast />
      </Pagination>
    </PaginationContext>
  );
};

export default PaginationComponent;
